import { useQuery } from '@tanstack/react-query';
import { CarrierWS } from '@/types/prestashop';

// Hook para obtener todos los transportistas
export const useCarriers = () => {
  return useQuery({
    queryKey: ['carriers'],
    queryFn: async (): Promise<CarrierWS[]> => {
      const response = await fetch('/api/es/carriers');
      if (!response.ok) {
        throw new Error('Error obteniendo transportistas');
      }
      const data = await response.json();
      return data.carriers;
    },
    staleTime: 5 * 60 * 1000, // 5 minutos
    gcTime: 10 * 60 * 1000, // 10 minutos
  });
};
